import React, { useState, useContext, useId, useRef } from "react";

import { DataContext } from "../../../context/DataContext";
import { simpleMessage } from "../../../helpers/Helpers";
import { getToken } from "../../../api/Account";
import { updatePuestoAsync } from "../../../api/Employees";
import { useAviso } from "../../../components/base";
import { ERROR_OTRA_SESION } from "../nomina/comunes";
import DialogoPuesto from "./DialogoPuesto";

const CambiarPuesto = ({ selected, setShowModal, localReload, setLocalReload }) => {
  const { id, description } = selected;
  const token = getToken();
  const { setIsLoading, setIsUnautorized } = useContext(DataContext);
  const aviso = useAviso();
  const idTitulo = useId();

  const [newDescription, setNewDescription] = useState(description);
  const [errorDescripcion, setErrorDescripcion] = useState("");
  // El overlay de carga no bloquea el teclado (Enter): el ref corta un segundo envío al instante.
  const enviando = useRef(false);
  const [guardando, setGuardando] = useState(false);

  const cambiar = (valor) => {
    setNewDescription(valor);
    if (errorDescripcion) setErrorDescripcion("");
  };

  const saveChangesAsync = async () => {
    if (enviando.current) {
      return;
    }
    if (newDescription.length === 0) {
      setErrorDescripcion("Ingrese el nombre del puesto");
      return;
    }
    if (newDescription === description) {
      setErrorDescripcion("Ingrese un nombre diferente al actual");
      return;
    }
    const data = {
      id,
      description: newDescription,
    };

    enviando.current = true;
    setGuardando(true);
    setIsLoading(true);
    let result;
    try {
      result = await updatePuestoAsync(token, data);
    } catch (e) {
      enviando.current = false;
      setGuardando(false);
      setIsLoading(false);
      aviso.error("No se pudo conectar con el servidor. Inténtalo de nuevo.");
      return;
    }
    enviando.current = false;
    setGuardando(false);
    if (!result.statusResponse) {
      setIsLoading(false);
      if (result.error === "Unauthorized") {
        setIsUnautorized(true);
        return;
      }
      if (result.error === ERROR_OTRA_SESION) {
        simpleMessage(result.error, "error");
        return;
      }
      aviso.error(result.error || "No se pudo guardar el puesto");
      return;
    }

    setIsLoading(false);
    aviso.exito("Puesto actualizado");
    setLocalReload(!localReload);
    setShowModal(false);
  };

  return (
    <DialogoPuesto
      idTitulo={`${idTitulo}-titulo`}
      titulo="Editar puesto"
      valor={newDescription}
      onCambio={cambiar}
      error={errorDescripcion}
      guardando={guardando}
      sucio={newDescription !== description}
      onGuardar={saveChangesAsync}
      onCerrar={() => setShowModal(false)}
    />
  );
};

/**
 * Diálogo para editar un puesto. Se dibuja solo si `abierto` y hay un puesto elegido: al
 * cerrarlo y volver a abrirlo empieza con el nombre actual del puesto.
 */
const EditPuesto = (props) => {
  if (props.abierto === false || !props.selected) return null;
  return <CambiarPuesto {...props} />;
};

export default EditPuesto;
